import React from 'react'

const PREP_COLOR = '#3b82c4'

export function QuadrantPicker({ options, value, onChange, disabled }) {
  const selected = value?.value ?? null
  // options: [excited, stressed, content, drained] — 2x2 grid
  return (
    <div style={styles.wrap}>
      <div style={styles.grid}>
        {options.map((opt) => {
          const isSelected = selected === opt.value
          return (
            <button
              key={opt.value}
              style={{
                ...styles.cell,
                ...(isSelected ? { background: PREP_COLOR + '18', borderColor: PREP_COLOR, color: 'var(--text-primary)', fontWeight: 600 } : {}),
                ...(disabled ? styles.disabled : {}),
              }}
              onClick={() => !disabled && onChange({ value: opt.value, label: opt.label })}
              disabled={disabled}
              aria-pressed={isSelected}
            >
              {opt.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}

const styles = {
  wrap: { padding: '12px 14px' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3px' },
  cell: {
    padding: '14px 8px', borderRadius: '4px',
    border: '1px solid var(--border)', background: 'transparent',
    fontSize: '12px', color: 'var(--text-secondary)', cursor: 'pointer',
    textAlign: 'center', transition: 'background var(--duration-fast) ease, border-color var(--duration-fast) ease',
  },
  disabled: { cursor: 'default', opacity: 0.7 },
}
